{
  "kampanya": {
    "Baslik": "Campagne Definities",
    "Ad": "Campagne Naam",
    "BasTarih": "Startdatum",
    "BitTarih": "Einddatum",
    "HedefEkle": "Doelen Toewijzen",
    "Kullanici Ata": "Gebruikers Toewijzen",
    "Kullanici Seç": "Selecteer Personeel/Gebruiker",
    "Kullanici Ad Soyad": "Naam Gebruiker",
    "Hedef Tutar": "Bedrag (₺)",
    "Hedef Adet": "Hoeveelheid",
    "PDO Orani": "PDO Verhouding (%)",
    "Urun Sec": "Productspecifiek",
    "Grup Sec": "Groepsdefinitie",
    "Urun Veya Grup": "Groep/Productnaam",
    "Filtrele": "Filteren",
    "Temizle": "Wissen",
    "ARA": "ZOEKEN",
    "Kapat": "Sluiten",
    "Ara": "Zoeken...",
    "Hepsi": "Alle",
    "Aktif": "Actief",
    "Pasif": "Inactief",
    "Durum": "Status",
    "Aciklama": "Beschrijving",
    "Duzenle": "Bewerken",
    "Yeni Ekle": "Nieuwe Toevoegen",
    "Ekle": "Toevoegen",
    "Guncelle": "Bijwerken",
    "Kaydet": "Opslaan",
    "Iptal": "Annuleren",
    "Islem": "Actie",
    "Yenile": "Vernieuwen",
    "Data Yenile": "Gegevens Vernieuwen",
    "Hedef yok": "Geen doelen toegewezen",
    "Kullanici yok": "Geen gebruikers toegewezen",
    "Hedef Dolar": "Dollardoel ($)",
    "Hedef APE": "APE-doel",
    "Tekil Kullanıcı Ekle": "Eén Gebruiker Toevoegen",
    "Toplu Kullanıcı Ekle (Takım/Şube)": "Bulkgebruikers Toevoegen (Team/Vestiging)",
    "Takım Bazlı": "Op Team Gebaseerde Selectie",
    "Şube Bazlı": "Op Vestiging Gebaseerde Selectie",
    "Toplu Ekle": "Bulk Toevoegen",
    "Takım": "Team"
  }
}
